<template>
  <div>
    <v-container>
      <v-row>
        <v-col :cols="12">
          <v-text-field
            :label="getCompanyLabels.services + ' Name'"
            v-model="name"
          ></v-text-field>
        </v-col>
        <v-col :cols="12">
          <v-text-field
            :label="getCompanyLabels.services + ' Code'"
            v-model="code"
          ></v-text-field>
        </v-col>
        <v-col :cols="12">
          <ForeignKeyField
            foreignColumn="category_id"
            :foreignTablesArray="['items_categories']"
            :foreignKeysArray="['category_id']"
            :foreignFieldValue="serviceCategory"
            :branchID="null"
            @field-selected="setCategory"
          ></ForeignKeyField>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row>
        <v-col :cols="4"
          ><v-text-field
            :label="isMobile ? getCompanyLabels.services + ' Cost' : 'Cost'"
            v-model="cost"
          ></v-text-field
        ></v-col>
        <v-col :cols="4"
          ><v-text-field
            :label="
              isMobile ? getCompanyLabels.services + 'Service Fee' : 'Fee'
            "
            v-model="price"
          ></v-text-field
        ></v-col>
        <v-col :cols="4">
          <v-autocomplete
            v-model="list"
            :items="['Yes', 'No']"
            dense
            color="teal"
            filled
            label="List On Store"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn dark rounded color="teal" large @click="createService()"
            ><v-icon left>mdi-check</v-icon>Create Service</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
import productsAndServicesJs from "@/plugins/productsAndServices";
import ForeignKeyField from "@/components/General/ForeignKeyField.vue";

export default {
  components: { ForeignKeyField },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  data: () => ({
    name: null,
    cost: 0,
    price: 0,
    code: null,
    categoryID: null,
    serviceCategory: null,
    list: "No",
  }),
  methods: {
    setCategory(vals) {
      this.categoryID = vals[0];
      this.serviceCategory = vals[1];
    },
    stripCommasFromMoney(amount) {
      return helpersJs.stripCommasFromMoney(amount);
    },
    async createService() {
      if (this.name && this.price && this.categoryID) {
        this.$store.commit("setLoader", true);
        this.cost = this.stripCommasFromMoney(this.cost);
        this.price = this.stripCommasFromMoney(this.price);

        const service = await productsAndServicesJs.createService(
          this.name,
          this.cost,
          this.price,
          this.categoryID,
          this.code,
          this.list
        );

        if (service == "exist") {
          this.$emit("exist", "Service Exist");
        } else {
          this.$emit("service-created", service);
          this.$store.commit("setLoader", false);
          this.$toast.success("Service Created Successfully!", {
            duration: 3000,
          });
        }
      } else {
        alert("Fill in at least Name, Cost, Service Fee and Category");
      }
    },
  },
};
</script>

<style></style>
